module.exports = __webpack_public_path__ + "static/media/properInteriorPackaging.e2510e1f.png";